var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPackage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.583 6.065 10.5 10.001m0 0L3.417 6.065m7.083 3.936v7.916m7.5-4.534V6.618c0-.285 0-.428-.042-.555a.833.833 0 0 0-.178-.304c-.091-.098-.216-.168-.466-.306l-6.166-3.426c-.237-.131-.355-.197-.48-.223a.834.834 0 0 0-.336 0c-.125.026-.243.092-.48.223L3.686 5.453c-.25.138-.375.208-.465.306a.833.833 0 0 0-.179.304C3 6.19 3 6.333 3 6.618v6.765c0 .285 0 .428.042.555a.833.833 0 0 0 .179.303c.09.1.215.168.465.307l6.166 3.426c.237.131.355.197.48.223.11.023.225.023.336 0 .125-.026.243-.092.48-.223l6.166-3.426c.25-.139.375-.208.465-.306a.832.832 0 0 0 .179-.304c.042-.127.042-.27.042-.555z",
    stroke: "#667085",
    strokeWidth: 1.667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 7.917 6.75 3.75",
    stroke: "#667085",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackage);
export default __webpack_public_path__ + "static/media/package.fb27a95b9c97d450b727d66ab16d6663.svg";
export { ForwardRef as ReactComponent };